import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../../../../filters';

export default {
  name: 'sampleDistribution',
  components: {
    EditableTable: require('../../../../customcontrols/editableTable.vue').default,
    DataGridComp: require('../../../../customcontrols/datagrid.vue').default,
    SendEmail: require('../../../../customcontrols/sendEmail.vue').default,
    DxReportViewer: require('@/customcontrols/dxReportViewer.vue').default,
  },
  props: {
    dataObj: {
      type: Object,
      default: []
    },
    valueField: {
      type: String,
      default: ''
    },
  },
  data: function () {
    return {
      tableCols: [],
      employeeName: '',
      laboratoryName: '',
      deliveryOfficer: '',
      showDialog: false,
      LabApplicationIssues: [],
      LabApplicationIssuesConfig: {},
      LabApplicationIssuesPageingOption: {
        pageSize: 0,
        total: 0,
        page: 1
      },
      CustomersList: [],
      CustomersListConfig: {},
      CustomersListPageingOption: {
        pageSize: 10,
        total: 0,
        page: 1
      },
      selectedObj: null,
      selectedSample: {},
      issueParameter: {},
      reportname: {},
      showIssueConfirmation: false,
      printReport: false,
      showSendEmail: false,
      selectedSampleId: '',
      reportName: '',
    }
  },
  created() {
    this.fillTableCols();
    this.LabApplicationIssuesConfigration();
  },
  watch: {

  },
  methods: {
    prepareReport(reportName, index, sourceType) {
      const options = {
        ApplicationId: this.dataObj.appId,
        ReportName: reportName,
        SourceType: sourceType
      };

      axios.post('/EmployeeApplication/PrepareActivityDxReport', options)
        .then(response => {
          if (response.status == 200) {
            //console.log("prepare report", response);
            if (response.data == '') {
              //this.setLabelReportPrinted(reportName, index, sourceType);

              //get path from router and add it to base url to open new tab with report
              let path = this.$router.resolve({ path: `/report/${reportName}` });
              open(window.location.origin + path.href);
            }
            else
              this.$alertMsg(response.data.data.text)
          }
          else {
            this.$alertMsg(response.data.text)
          }
        })
        .catch(errpr => {
          this.$alertMsg(errpr.response.data);
        });
    },
    printDistributionReport(param, index) {
      this.getReport(param, index, 5)
        .then(getResult => this.prepareReport(getResult.reportName, index, 5));
    },
    emailDistributionReport(param, index) {
      //TBI
      //console.log("sample id", this.dataObj.appData.samples[index].sampleId);
      this.selectedSampleId = this.dataObj.appData.samples[index].sampleId;

      this.getReport(param, index, '5')
        .then(result => {
          this.getCustomersList()
            .then(result1 => {
              this.reportName = result.reportName;
              this.showSendEmail = true
            });
        });
    },
    printLabelsReport(param, index) {
      this.getReport(param, index, 6)
        .then(getResult => {
          this.prepareReport(getResult.reportName, index, 6);
          this.setLabelReportPrinted(getResult.reportName, index, 6);
        });
    },
    getReport(param, index, sourceType) {
      //source type: 5 for distibution - 6 for label
      const appId = this.dataObj.appId;

      return axios.get('/EmployeeApplication/GetCurrentActivityDxReports?applicationId=' + appId + '&sourceType=' + sourceType)
        .then(response => {
          if (response.status == 200) {
            //console.log("response",response);
            return response.data.items[0];
          }
          else
            this.$alertMsg(response.data.data.text)
        })
        .catch(errpr => {
          this.$alertMsg(errpr.response.data);
        });
    },
    setLabelReportPrinted(reportName, index, sourceType) {     
      const parameter =
      {
        ...this.getParameterBase(),
        SourceType: sourceType,
        SampleId: this.dataObj.appData.samples[index].sampleId,
        ReportName: reportName
      };

      axios.post('/SampleDistributionActivity/SetDxReportPrinted', parameter)
        .then(response => {
          if (response.status == 200) {
            this.dataObj.appData.samples[index].labelReportPrinted = true;
          }
          else
            this.$alertMsg(response.data.data.text)
        })
        .catch(errpr => {
          this.$alertMsg(errpr.response.data);
        });
    },
    getCustomersList(pageOpt = null) {
      var opt = {};

      if (pageOpt == null) {
        opt = {
          Page: this.CustomersListPageingOption.page,
          PageSize: this.CustomersListPageingOption.pageSize
        };
      } else {
        opt = pageOpt;
      }

      const options = {
        Options: opt,
        ApplicationId: this.dataObj.appId,
        ApplicationKey: this.dataObj.appKey,
        Filters: {
          ConsentReceiveEmail: true
        }
      };

      return axios.post('/SampleDistributionActivity/GetCustomers', options)
        .then(response => {
          if (response.status == 200) {
            this.fillCustomersListConfig(response.data.itemsCount);
            //console.log("cust list", response.data.items);
            response.data.items.forEach(element => element['selected'] = false);
            this.CustomersList = response.data.items;
            return this.CustomersList;
          }
          else
            this.$alertMsg(response.data.text)
        })
        .catch(errpr => {
          this.$alertMsg(errpr.response.data);
        });
    },
    fillCustomersListConfig(totalRows) {
      this.CustomersListConfig.keyColumn = 'surname';
      this.CustomersListConfig.pageOptions = this.CustomersListPageingOption;
      this.CustomersListConfig.totalRows = totalRows;
      this.CustomersListConfig['cols'] = [];
      this.CustomersListConfig['cols'].push({ caption: this.$t('sendEmail.selected'), dataField: 'selected' });
      this.CustomersListConfig['cols'].push({ caption: this.$t('sendEmail.email'), dataField: 'email' });
      this.CustomersListConfig['cols'].push({ caption: this.$t('sendEmail.name'), dataField: 'surname', dataType: 'string' });
      this.CustomersListConfig['cols'].push({ caption: this.$t('sendEmail.phoneNo'), dataField: 'telephoneNumber' });
      this.CustomersListConfig['cols'].push({ caption: this.$t('sendEmail.workNo'), dataField: 'workTelNo' });
      this.CustomersListConfig['cols'].push({ caption: this.$t('sendEmail.address'), dataField: 'address' });
    },
    ConfirmIssueReporting() {
      this.showIssueConfirmation = false;
      this.showDialog = true;
    },
    cancelIssueReporting() {
      this.showIssueConfirmation = false;
      this.issueParameter = null;
    },
    submitLabAppIssue() {
      //error trap
      if (this.selectedObj == null || this.selectedObj.typeId < 0) {
        this.issueParameter = null;
        return;
      }
      //save type id of selecred
      this.issueParameter['TypeId'] = this.selectedObj.typeId;

      //save selected sample before selection changes
      var sltcdSmpl = this.selectedSample;

      axios.post('/SampleDistributionActivity/IssueLaboratoryApplication', this.issueParameter)
        .then(response => {
          if (response.status == 200) {
            //console.log(response);
            const applicationId = response.data;
            sltcdSmpl.laboratoryApplicationId = applicationId;
            window.open(window.location.origin + '/application/' + applicationId);
          }
          else
            this.$alertMsg(response.data.data.text)
        })
        .catch(errpr => {
          this.$alertMsg(errpr.response.data);
        });
    },
    showIssueDialog(item, index, col) {
      if (item.laboratoryApplicationId > 0) {
        //we already have issue - open it
        window.open(window.location.origin + '/application/' + item.laboratoryApplicationId);
      } else {
        this.selectedSample = item;

        this.issueParameter =
        {
          ...this.getParameterBase(),
          //some data are here some will get after user selection
          TypeId: '',
          SampleId: item.sampleId,
        }
        //show confirmation dialog for user 
        this.showIssueConfirmation = true;
      }
    },
    pageChange() {
      return this.dataObj.appData.applicationTypes;
    },
    rowSelected(info) {
      this.selectedObj = info.data;
      this.displayedValue = this.displayField == '' ? '' : this.selectedObj[this.displayField];
      this.submitLabAppIssue();
      this.showDialog = false;

      if (this.selection)
        this.selection(this.selectedObj);
    },
    LabApplicationIssuesConfigration() {
      this.LabApplicationIssuesConfig['keyColumn'] = 'typeId';
      this.LabApplicationIssuesConfig['pageOptions'] = this.LabApplicationIssuesPageingOption;
      this.LabApplicationIssuesConfig['cols'] = [];
      this.LabApplicationIssuesConfig['cols'].push({ dataField: 'group', caption: this.$t('lims.group') });
      this.LabApplicationIssuesConfig['cols'].push({ dataField: 'name', caption: this.$t('lims.name') });
    },
    fillTableCols() {
      this.tableCols = [];
      this.tableCols.push({ label: this.$t('lims.laboratory'), property: 'laboratoryId', allowEdit: true, dataType: 'select', dataSource: this.dataObj.appData.laboratories, displayField: 'text', valueField: 'value', displayModel: 'laboratory', required: true });
      this.tableCols.push({ label: this.$t('lims.laboratoryApplicationId'), property: 'laboratoryId', allowEdit: false, dataType: 'string', });
      this.tableCols.push({ label: this.$t('lims.ref'), property: 'ref', allowEdit: true, dataType: 'string', required: true });
      this.tableCols.push({ label: this.$t('lims.noOfBottles'), property: 'noOfBottles', allowEdit: true, dataType: 'number', required: true });
      this.tableCols.push({ label: this.$t('lims.deliveryOfficer'), property: 'deliveryEmployeeId', allowEdit: true, dataType: 'select', dataSource: this.dataObj.appData.employees, displayField: 'displayString', valueField: 'employeeId', displayModel: 'deliveryEmployee', required: true });
      this.tableCols.push({ label: this.$t('lims.labelsReport'), property: 'labelsReport', allowEdit: true, dataType: 'button', buttonTitle: this.$t('lims.print'), buttonCallBackFunc: this.printLabelsReport });
      this.tableCols.push({ property: 'labelReportPrinted', allowEdit: false, dataType: 'boolean' });
      this.tableCols.push({ label: this.$t('lims.distributionReport'), property: 'distributionReport', allowEdit: true, dataType: 'button', buttonTitle: this.$t('lims.print'), buttonCallBackFunc: this.printDistributionReport });
      this.tableCols.push({ label: '', property: 'distributionReport', allowDissableButton: true, allowEdit: true, dataType: 'button', buttonTitle: this.$t('lims.email'), buttonCallBackFunc: this.emailDistributionReport });
      this.tableCols.push({ label: this.$t('lims.issueLaboratoryApplication'), property: 'issueLaboratoryApplication', allowEdit: true, dataType: 'button', buttonTitle: this.$t('lims.issue'), buttonCallBackFunc: this.showIssueDialog });
      this.tableCols.push({ label: this.$t('lims.laboratoryApplicationId'), property: 'laboratoryApplicationId', dataType: 'string' });
    },
    getParameterBase() {
      //if user active we send 0 else user in history we send appkey
      let isUserActive = window.location.href.indexOf('/application/') >= 0 ? true : false; //TBI

      return {
        ApplicationId: this.dataObj.appId,
        ApplicationKey: isUserActive ? 0 : this.dataObj.appKey,
      }
    },
    saveDistribution(item, index) {
      const parameter =
      {
        ...this.getParameterBase(),
        sample: {
          Ref: item.ref,
          LaboratoryId: item.laboratoryId,
          DeliveryEmployeeId: item.deliveryEmployeeId,
          //force value to false if empty
          LabelReportPrinted: item.labelReportPrinted ? true : false,
          noOfBottles: item.noOfBottles
        }
      };
      
      //sample id exists so edit instead create new element
      if (this.dataObj.appData.samples[index].sampleId >= 0)
        parameter.sample['SampleId'] = this.dataObj.appData.samples[index].sampleId;

      axios.post('/SampleDistributionActivity/InsertOrReplace', parameter)
        .then(response => {
          if (response.status == 200) {
            this.dataObj.appData.samples[index]['sampleId'] = response.data;
            this.$alertMsg(this.$t('lims.sampleSaved'), 2);
          }
          else
            this.$alertMsg(response.data.data.text)
        })
        .catch(errpr => {
          this.$alertMsg(errpr.response.data);
        });
    },
    deleteDistribution(index) {
      //error trap
      if (index == null || index < 0)
        return;

      //console.log(this.dataObj.appData.samples);
      if (this.dataObj.appData.samples[index].laboratoryApplicationId > 0) {
        this.$alertMsg(this.$t('lims.issueSubmitedError'));
        return;
      }

      const parameter =
      {
        data: {
          ...this.getParameterBase(),
          sampleId: this.dataObj.appData.samples[index].sampleId
        }
      };

      axios.post('/SampleDistributionActivity/Delete', parameter)
        .then(response => {
          if (response.status == 200) {
            //remove row from dataObject/gui
            this.dataObj.appData.samples.splice(index, 1);
            this.$alertMsg(this.$t('lims.sampleDeleted'), 2);
          }
          else
            this.$alertMsg(response.data.data.text)
        })
        .catch(errpr => {
          this.$alertMsg(errpr.response.data);
        });
    },
    disablelButton(item, buttName) {
      if (buttName === this.$t('lims.print'))
        return item.labelReportPrinted ? true : false;
      else
        return false;
    },
    validateAppData() {
      return true;
    },
    exitSendMail() {
      //exit email window
      this.showSendEmail = false;
    }
  }
}

